module.exports = __webpack_public_path__ + "static/img/before2.b772418.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/before2.jpg
// module id = vypD
// module chunks = 9